import { render, staticRenderFns } from "./NotificationsTab.vue?vue&type=template&id=35787aba&scoped=true"
import script from "./NotificationsTab.vue?vue&type=script&lang=js"
export * from "./NotificationsTab.vue?vue&type=script&lang=js"
import style0 from "./NotificationsTab.vue?vue&type=style&index=0&id=35787aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35787aba",
  null
  
)

export default component.exports